import { Fragment, useMemo, type ReactNode } from 'react'
import { Box, Link, Typography } from '@mui/material'
import { parseTelegramHtml, type TelegramNode } from '@/utils/telegramHtml'

function renderNodes(nodes: TelegramNode[], prefix: string): ReactNode[] {
  return nodes.map((node, index) => {
    const key = `${prefix}${index}`

    if (node.type !== 'element') {
      return <Fragment key={key}>{node.text}</Fragment>
    }

    const children = renderNodes(node.children, `${key}.`)

    if (node.tag === 'b') return <strong key={key}>{children}</strong>
    if (node.tag === 'i') return <em key={key}>{children}</em>
    if (node.tag === 'u') return <u key={key}>{children}</u>
    if (node.tag === 's') return <s key={key}>{children}</s>
    if (node.tag === 'code') {
      return (
        <Box
          key={key}
          component="code"
          sx={{ fontFamily: 'monospace', bgcolor: 'action.hover', px: 0.5, borderRadius: 0.5 }}
        >
          {children}
        </Box>
      )
    }
    if (node.href !== null) {
      return (
        <Link key={key} href={node.href} target="_blank" rel="noopener noreferrer nofollow">
          {children}
        </Link>
      )
    }

    return <Fragment key={key}>{children}</Fragment>
  })
}

/**
 * Подпись поста Telegram так, как её покажет канал: разрешённые теги — React-
 * элементами, остальная разметка — текстом (см. parseTelegramHtml).
 */
export function TelegramCaption({ html }: { html: string }) {
  const content = useMemo(() => renderNodes(parseTelegramHtml(html), ''), [html])

  return (
    <Typography component="div" variant="body2" sx={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>
      {content}
    </Typography>
  )
}
